/**
 * MVP status indicator. The prop is an array so a collapsible activity
 * timeline is an additive fast-follow — for now we render only the latest.
 */

import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export interface StatusEntry {
  stage?: string;
  label: string;
}

interface StatusChipProps {
  statuses: StatusEntry[];
}

const StatusChip: React.FC<StatusChipProps> = ({ statuses }) => {
  if (statuses.length === 0) return null;
  const latest = statuses[statuses.length - 1];

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignSelf: 'flex-start',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.5,
        borderRadius: 999,
        bgcolor: 'action.hover',
        color: 'text.secondary',
        whiteSpace: 'nowrap',
      }}
    >
      <CircularProgress size={12} thickness={6} />
      <Typography variant="caption" sx={{ fontWeight: 500 }}>
        {latest.label}
      </Typography>
    </Box>
  );
};

export default React.memo(StatusChip);
